import React, { Component } from 'react';
import SearchBar from '../containers/search_bar';
import WeatherList from '../containers/weather_list';

export default class App extends Component {
  render() {
    return (
      <div>
          <div className="row justify-content-center">
                <SearchBar/>
          </div>
          
          <WeatherList/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app.js